var origTables;
$(document).ready(function(){

	if ($("html").attr("data-bank") == "PBZ") {
		var tables = $("div[data-type-table]");
		var today = new Date();
		var euroDate = new Date("2023-01-01");
		origTables = tables.clone();
		$(tables).each(function(index){
			var table = $(this);
			var tableType = table.attr("data-type-table");
			var refCurrency = "&refCurrency=";
			if(today < euroDate){
				refCurrency += "HRK";
			}
			else{
				refCurrency += "EUR";
			}
			var endpoint = window.location.origin + $("#exchange-rates-"+tableType.toLowerCase()+"-endpoint").val() + refCurrency;
				getJsonAjax(endpoint, $("#exchange-rates-"+tableType.toLowerCase()), tableType, false, '');
		});
	}
});
createTable = function(tableType, isArchive, datePickerId){
	var jsonToFormat = $("#ecb-rates").val();
	var jsonToFormatArchive = $("#ecb-rates-archive").val();
	var jsonFormatted = '{"0":{"' + jsonToFormat.slice(jsonToFormat.indexOf("Cube"));
	var jsonFormattedArchive = '{"0":{"' + jsonToFormatArchive.slice(jsonToFormat.indexOf("Cube"));
	console.log($("div[data-type-table]").length);
	var table = $("div[data-type-table="+tableType+"]");
	var indexForEcbArchive = 0;
		var json = $("#exchange-rates-"+tableType.toLowerCase()).val();
		if(isArchive){
			var jsonEcb = JSON.parse(jsonFormattedArchive);
//			var datePicker = $("#"+datePickerId);
//			var formattedDate = formatDate(formatSlashedDate(datePicker.val().slice(0,10).replaceAll(".", "/")));
//			indexForEcbArchive = findEcbArchiveJsonIndex(jsonEcb, formattedDate);
		} else {
			var jsonEcb = JSON.parse(jsonFormatted);
		}
		if(json != ""){
			var obj = JSON.parse(json);
			var validFromDate = new Date(obj.rates[0].validFromDate);
			var defined = new Date(obj.rates[0].defined);
			if((tableType == 'PBZ-ISSUING' || tableType == 'PBZ-CARD-ISSUING') && isArchive){
				var validFromDate = new Date(obj.rates[obj.rates.length -1].validFromDate);
				var defined = new Date(obj.rates[obj.rates.length -1].defined);
			}
			var validFromFormatted = validFromDate.getDate() +"."+(validFromDate.getMonth()+1) +"."+validFromDate.getFullYear();
			$(".-js-date-exchange-valid-"+tableType).text(validFromFormatted);
			var hours = defined.getHours();
			var minutes = defined.getMinutes();
			if(hours < 10){
				hours = "0" + hours;
			}
			if(minutes < 10){
				minutes = "0" + minutes;
			}
			var validDefined = defined.getDate() +"."+(defined.getMonth()+1) +"."+defined.getFullYear() +"; " + hours + ":" + minutes;
			$(".-js-date-exchange-"+tableType).text(validDefined);
			var clonedTable = table.clone();
			var columnsList = table.find("ul.tbl2__highlist");
			var columnsRow = columnsList.find("li.tbl2__highlistItem");
			var columnsRowList = columnsRow.find("ul.tbl__highlist");
			var columns = columnsRowList.find("li.tbl__highlistItem");
			var head = table.find(".tbl2__head__highlist");
			var totalColumns = head.find(".tbl__highlistItem").length;
		    columnsRowList.html("");
		    columnsList.html("");
		    if(tableType == 'ATM-DCC' || tableType == 'POS-DCC'){
		    	$.each(obj.rates, function(key, value) {
		   	     var clonedRow = columnsRow.clone();
		   		    var jsonValue = value;
		   	        var columnsRowListCloned = columnsRowList.clone();
		   	        var valueResult ="";
		   	        var currencyFrom = jsonValue.exRate.currencyFrom;
		   	        var currencyFromLabel = currencyFrom.label.toUpperCase();
		   	        var currencyTo = jsonValue.exRate.currencyTo;
				    var currencyToLabel = currencyTo.label;
		   		    for(i = 0; i <totalColumns; i++){
		   		    	var cloned = columns.clone();
		   		    	switch(i) {
		   		    	  case 0:
		   		    		  valueResult = currencyFromLabel;
		   		    	    break;
		   		    	  case 1:
		   		    	    valueResult = currencyFrom.code;
		   		    	    break;
		   		    	  case 2:
		   			    	 valueResult = jsonValue.exRate.units;
		   			    	    break;
		   		    	  case 3:
		   			    	    //to do atm rate
		   		    		  valueResult = formatNumber(jsonValue.exRate.rate);
		   			    	    break;
		   			    	   
		   		    	  case 4:
		   		    		  	var cubeArray = [];
		   		    		  	if(isArchive){
		   		    		  		indexForEcbArchive = findEcbArchiveJsonIndex(jsonEcb, jsonValue.validFromDate);
		   		    		  		cubeArray = jsonEcb[0].Cube.Cube[indexForEcbArchive].Cube;
		   		    		  	} else {
		   		    		  		cubeArray = jsonEcb[0].Cube.Cube.Cube;
		   		    		  	}
		   		    		  	var toRates = 0;
		   		    		  	var fromRates = 0;
		   		    		  	for(c = 0; c < cubeArray.length; c++){
		   		    		  		if(cubeArray[c].currency == currencyFromLabel){
		   		    		  			fromRates = cubeArray[c].rate;
		   		    		  		}
		   		    		  		if(cubeArray[c].currency == currencyToLabel){
		   		    		  			toRates = cubeArray[c].rate;
		   		    		  		}
		   		    		  	}

								if(currencyFromLabel === "EUR") {
									fromRates = 1;
								}
								
		   		    		  	valueResult = calculateRateFormula(jsonValue.exRate.rate,toRates, fromRates, currencyToLabel);
		   			    	    break;
		   		    	  case 5:
		   		    		  valueResult = currencyTo.code;
		   			    	    break;
		   		    	  case 6:
		   		    		  valueResult = currencyTo.label;
		   			    	    break;
		   		    	  default:
		   		    	    valueResult = "";
		   		    	} 
		   		    	cloned.html('<span class="tbl__highlistLabel"></span><span class="tbl__highlistValue"><strong>'+valueResult+'</strong></span>');
		   		    	columnsRowListCloned.append(cloned)
		   	        }
		   		    	clonedRow.append(columnsRowListCloned);
		   		    	
		
		   		    columnsList.append(clonedRow);
		   		});
		    } else if (tableType == 'PBZ-ISSUING' || tableType == 'PBZ-CARD-ISSUING') {
		    	$.each(obj.rates, function(key, value) {
		   	     var clonedRow = columnsRow.clone();
		   		    var jsonValue = value;
		   		    var fromCurrency = jsonValue.fromCurrency;
		   		    var fromCurrencyLabel = fromCurrency.label;
		   		    var toCurrency = jsonValue.toCurrency;
		   		    var toCurrencyLabel = toCurrency.label;
		   	        var columnsRowListCloned = columnsRowList.clone();
		   	        var valueResult ="";
		   		    for(i = 0; i <totalColumns; i++){
		   		    	var cloned = columns.clone();
		   		    	if(tableType == 'PBZ-ISSUING'){
			   		    	switch(i) {
			   		    	  case 0:
			   		    		if(isArchive){
			   		    			valueResult = fromCurrencyLabel;
			   		    		} else {
			   		    			valueResult = toCurrencyLabel;
			   		    		}			   		    		  
			   		    	    break;
			   		    	  case 1:
			   		    		if(isArchive){
			   		    			valueResult = fromCurrency.code;
			   		    		} else {
			   		    			valueResult = toCurrency.code;
			   		    		}
			   		    	    break;
			   		    	  case 2:
			   			    	 valueResult = jsonValue.buyRate.units;
			   			    	    break;
			   		    	  case 3:
			   			    	    //to do atm rate
			   		    		  valueResult = formatNumber(jsonValue.buyRateCash.rate);
			   			    	    break;
			   		    	  case 4:
			   		    		 valueResult = formatNumber(jsonValue.buyRateCurrency.rate);
			   		    		 break;
			   		    	  case 5:
			   		    		  	var cubeArray = [];
			   		    		  	if(isArchive){
			   		    		  		indexForEcbArchive = findEcbArchiveJsonIndex(jsonEcb, jsonValue.validFromDate);
			   		    		  		cubeArray = jsonEcb[0].Cube.Cube[indexForEcbArchive].Cube;
			   		    		  	} else {
			   		    		  		cubeArray = jsonEcb[0].Cube.Cube.Cube;
			   		    		  	}
			   		    		  	var toRates = 0;
			   		    		  	var fromRates = 0;
				   		    		 if(isArchive){
					   		    		  for(c = 0; c < cubeArray.length; c++){
					   		    		  		if(cubeArray[c].currency == toCurrencyLabel){
					   		    		  			fromRates = cubeArray[c].rate;
					   		    		  		}
					   		    		  		if(cubeArray[c].currency == fromCurrencyLabel){
					   		    		  			toRates = cubeArray[c].rate;
					   		    		  		}
					   		    		  }
				   		    		 } else {
				   		    		  	for(c = 0; c < cubeArray.length; c++){
				   		    		  		if(cubeArray[c].currency == fromCurrencyLabel){
				   		    		  			fromRates = cubeArray[c].rate;
				   		    		  		}
				   		    		  		if(cubeArray[c].currency == toCurrencyLabel){
				   		    		  			toRates = cubeArray[c].rate;
				   		    		  		}
				   		    		  	}
				   		    		 }

				   		    		  	var rateToDivide = jsonValue.buyRateCurrency.rate;
				   		    		 if(isArchive){
				   		    		  	if(toCurrencyLabel !== "EUR" && fromCurrencyLabel == "HUF"){
				   		    		  		
				   		    		  		rateToDivide = jsonValue.buyRateCurrency.rate / 100;
				   		    		  	}
				   		    		  	var columnNumber = 5;
				   		    		  	valueResult = calculateCardIssuingRateFormula(rateToDivide,fromRates, toRates, fromCurrencyLabel, tableType, columnNumber, toCurrencyLabel);
				   		    		 } else {
				   		    		  	if( fromCurrencyLabel !== "EUR" && toCurrencyLabel == "HUF"){
				   		    		  		
				   		    		  		rateToDivide = jsonValue.buyRateCurrency.rate / 100;
				   		    		  	}
				   		    		  	var columnNumber = 5;
					   		    		valueResult = calculateCardIssuingRateFormula(rateToDivide,fromRates, toRates, toCurrencyLabel, tableType, columnNumber, fromCurrencyLabel);
				   		    		 }
			   			    	    break;
			   		    	  case 6:
			   		    		  valueResult = formatNumber(jsonValue.meanRate.rate);
			   			    	    break;
			   		    	  case 7:
			   		    		  valueResult = formatNumber(jsonValue.sellingRateCurrency.rate);	   			    	    
			   		    		  break;
			   		    	  case 8:
			   		    		  	var cubeArray = [];
			   		    		  	if(isArchive){
			   		    		  		indexForEcbArchive = findEcbArchiveJsonIndex(jsonEcb, jsonValue.validFromDate);
			   		    		  		cubeArray = jsonEcb[0].Cube.Cube[indexForEcbArchive].Cube;
			   		    		  	} else {
			   		    		  		cubeArray = jsonEcb[0].Cube.Cube.Cube;
			   		    		  	}
			   		    		  	var toRates = 0;
			   		    		  	var fromRates = 0;
			   		    		 if(isArchive){
			   		    		  	for(c = 0; c < cubeArray.length; c++){
			   		    		  		if(cubeArray[c].currency == toCurrencyLabel){
			   		    		  			fromRates = cubeArray[c].rate;
			   		    		  		}
			   		    		  		if(cubeArray[c].currency == fromCurrencyLabel){
			   		    		  			toRates = cubeArray[c].rate;
			   		    		  		}
			   		    		  	} 
			   		    		 } else {
			   		    		  	for(c = 0; c < cubeArray.length; c++){
			   		    		  		if(cubeArray[c].currency == fromCurrencyLabel){
			   		    		  			fromRates = cubeArray[c].rate;
			   		    		  		}
			   		    		  		if(cubeArray[c].currency == toCurrencyLabel){
			   		    		  			toRates = cubeArray[c].rate;
			   		    		  		}
			   		    		  	} 
			   		    		 }
								 
			   		    		  	var rateToDivide = jsonValue.sellingRateCurrency.rate;
			   		    		 if(isArchive){
			   		    		  	if(toCurrencyLabel !== "EUR" && fromCurrencyLabel == "HUF"){
			   		    		  		
			   		    		  		rateToDivide = jsonValue.sellingRateCurrency.rate / 100;
			   		    		  	}
					    		  	var columnNumber = 8;
			   		    		    valueResult = calculateCardIssuingRateFormula(rateToDivide,fromRates, toRates, fromCurrencyLabel, tableType, columnNumber, toCurrencyLabel);
			   		    		 } else {
				   		    		if(fromCurrencyLabel !== "EUR" && toCurrencyLabel == "HUF"){
			   		    		  		
			   		    		  		rateToDivide = jsonValue.sellingRateCurrency.rate / 100;
			   		    		  	}
					    		  	var columnNumber = 8;
			   		    		    valueResult = calculateCardIssuingRateFormula(rateToDivide,fromRates, toRates, toCurrencyLabel, tableType, columnNumber, fromCurrencyLabel);
			   		    		 }
			   		    	    break;
			   		    	  case 9:
			   		    		  valueResult = formatNumber(jsonValue.sellingRateCash.rate);
			   			    	    break;
			   		    	  case 10:
			   		    		  	var cubeArray = [];
			   		    		  	if(isArchive){
			   		    		  		indexForEcbArchive = findEcbArchiveJsonIndex(jsonEcb, jsonValue.validFromDate);
			   		    		  		cubeArray = jsonEcb[0].Cube.Cube[indexForEcbArchive].Cube;
			   		    		  	} else {
			   		    		  		cubeArray = jsonEcb[0].Cube.Cube.Cube;
			   		    		  	}
			   		    		  	var toRates = 0;
			   		    		  	var fromRates = 0;
				   		    		 if(isArchive){
				   		    		  	for(c = 0; c < cubeArray.length; c++){
				   		    		  		if(cubeArray[c].currency == toCurrencyLabel){
				   		    		  			fromRates = cubeArray[c].rate;
				   		    		  		}
				   		    		  		if(cubeArray[c].currency == fromCurrencyLabel){
				   		    		  			toRates = cubeArray[c].rate;
				   		    		  		}
				   		    		  	} 
				   		    		 } else {
				   		    		  	for(c = 0; c < cubeArray.length; c++){
				   		    		  		if(cubeArray[c].currency == fromCurrencyLabel){
				   		    		  			fromRates = cubeArray[c].rate;
				   		    		  		}
				   		    		  		if(cubeArray[c].currency == toCurrencyLabel){
				   		    		  			toRates = cubeArray[c].rate;
				   		    		  		}
				   		    		  	} 
				   		    		 }

			   		    		  	var rateToDivide = jsonValue.sellingRateCash.rate;
				   		    		 if(isArchive){
				   		    		  	if(toCurrencyLabel !== "EUR" && fromCurrencyLabel == "HUF"){
				   		    		  		
				   		    		  		rateToDivide = jsonValue.sellingRateCash.rate / 100;
				   		    		  	}
				   		    		  	var columnNumber = 10;
				   		    		    valueResult = calculateCardIssuingRateFormula(rateToDivide,fromRates, toRates, fromCurrencyLabel, tableType, columnNumber, toCurrencyLabel);

				   		    		 } else {
				   		    			if(fromCurrencyLabel !== "EUR" && toCurrencyLabel == "HUF"){
				   		    		  		
				   		    		  		rateToDivide = jsonValue.sellingRateCash.rate / 100;
				   		    		  	} 
				   		    		  	var columnNumber = 10;
				   		    		    valueResult = calculateCardIssuingRateFormula(rateToDivide,fromRates, toRates, toCurrencyLabel, tableType, columnNumber, fromCurrencyLabel);
				   		    		 }
			   			    	    break;
			   		    	  default:
			   		    	    valueResult = "";
			   		    	} 
		   		    	}
		   		    	if(tableType == 'PBZ-CARD-ISSUING'){
			   		    	switch(i) {
			   		    	  case 0:
			   		    		  if(isArchive){
			   		    			valueResult = fromCurrencyLabel;  
			   		    		  } else {
			   		    			 valueResult = toCurrencyLabel;  
			   		    		  }
			   		    	    break;
			   		    	  case 1:
			   		    		  if(isArchive){
			   		    			 valueResult = fromCurrency.code;  
			   		    		  } else {
			   		    			  valueResult = toCurrency.code;
			   		    		  }
			   		    	    break;
			   		    	  case 2:
			   			    	 valueResult = jsonValue.buyRate.units
			   			    	    break;
			   		    	  case 3:
			   			    	    //to do atm rate
			   		    		  valueResult = formatNumber(jsonValue.buyRateCash.rate);
			   			    	    break;
			   		    	  case 4:
			   		    		 valueResult = formatNumber(jsonValue.buyRateCurrency.rate);
			   		    		 break;
			   		    	  case 5:
			   		    		  valueResult = formatNumber(jsonValue.meanRate.rate);
			   			    	    break;
			   		    	  case 6:
			   		    		  valueResult = formatNumber(jsonValue.sellingRateCurrency.rate);
			   			    	    break;
			   		    	  case 7:
			   		    		  	var cubeArray = [];
			   		    		  	if(isArchive){
			   		    		  		indexForEcbArchive = findEcbArchiveJsonIndex(jsonEcb, jsonValue.validFromDate);
			   		    		  		cubeArray = jsonEcb[0].Cube.Cube[indexForEcbArchive].Cube;
			   		    		  	} else {
			   		    		  		cubeArray = jsonEcb[0].Cube.Cube.Cube;
			   		    		  	}
			   		    		  	var toRates = 0;
			   		    		  	var fromRates = 0;
			   		    		  	for(c = 0; c < cubeArray.length; c++){
			   		    		  		if(isArchive){
				   		    		  		if(cubeArray[c].currency == toCurrencyLabel){
				   		    		  			fromRates = cubeArray[c].rate;
				   		    		  		}
				   		    		  		if(cubeArray[c].currency == fromCurrencyLabel){
				   		    		  			toRates = cubeArray[c].rate;
				   		    		  		}
			   		    		  		} else {
				   		    		  		if(cubeArray[c].currency == fromCurrencyLabel){
				   		    		  			fromRates = cubeArray[c].rate;
				   		    		  		}
				   		    		  		if(cubeArray[c].currency == toCurrencyLabel){
				   		    		  			toRates = cubeArray[c].rate;
				   		    		  		}	
			   		    		  		}
			   		    		  	}
									
			   		    		  	var rateToDivide = jsonValue.sellingRateCurrency.rate;
			   		    		  	if(isArchive){
				   		    		  	if(toCurrencyLabel !== "EUR" && fromCurrencyLabel == "HUF"){
				   		    		  		
				   		    		  		rateToDivide = jsonValue.sellingRateCurrency.rate / 100;
				   		    		  	}
				   		    		  	var columnNumber = 7;
				   		    		  	valueResult = calculateCardIssuingRateFormula(rateToDivide,fromRates, toRates, fromCurrencyLabel, tableType, columnNumber, toCurrencyLabel);

			   		    		  	} else {
				   		    		  	if(fromCurrencyLabel !== "EUR" && toCurrencyLabel == "HUF"){
				   		    		  		
				   		    		  		rateToDivide = jsonValue.sellingRateCurrency.rate / 100;
				   		    		  	}
				   		    		  	var columnNumber = 7;
				   		    		  	valueResult = calculateCardIssuingRateFormula(rateToDivide,fromRates, toRates, toCurrencyLabel, tableType, columnNumber, fromCurrencyLabel);

			   		    		  	}
			   			    	    break;
			   		    	  case 8:
			   		    		  valueResult = formatNumber(jsonValue.sellingRateCash.rate);
			   			    	    break;
		//	   		    	  case 9:
		//	   		    		  valueResult = toCurrencyLabel;
		//	   			    	    break;
			   		    	  default:
			   		    	    valueResult = "";
			   		    	} 
		   		    	}
		   		    	cloned.html('<span class="tbl__highlistLabel"></span><span class="tbl__highlistValue"><strong>'+valueResult+'</strong></span>');
		   		    	columnsRowListCloned.append(cloned)
		   	        }
		   		    	clonedRow.append(columnsRowListCloned);
		   		    	
		
		   		    columnsList.append(clonedRow);
		   		});
		    }
		    json2xml(tableType, null);
		}

}

calculateRateFormula = function(atmRate, toMoneyEcbRate, fromMoneyEcbRate, currency){
	result = 0;
		if(currency == "EUR"){
			toMoneyEcbRate = 1;
		}
		if(currency == "CHF" || 
				currency == "CZK" || 
				currency == "DKK" || 
				currency == "HUF" ||
				currency == "NOK" ||
				currency == "PLN" ||
				currency == "SEK" ||
				currency == "HRK" ||
				currency == "EUR") {
		
			result = (atmRate / (toMoneyEcbRate/fromMoneyEcbRate) -1) * 100;
		} else {
			return "-";
		}
	return Number(result).toFixed(2) + "%";
	
}


calculateCardIssuingRateFormula = function(sellingRateForeing, fromEcbRate, toEcbRate, currency, tableType, columnNumber, refCurrency){
	refCurrency = refCurrency || "EUR";

	result = 0;
		if(currency == "EUR"){
			toEcbRate = fromEcbRate;
			result = ((sellingRateForeing - toEcbRate) / fromEcbRate) * 100;
		} else if (currency == "CHF" || 
				currency == "CZK" || 
				currency == "HUF" ||
				currency == "NOK" ||
				currency == "PLN" ||
				currency == "SEK" ||
				currency == "HRK") {

			if(refCurrency === "EUR") {
				result = ecbRatioFormulaEur(toEcbRate, sellingRateForeing);
			}
			else {
				result = ((sellingRateForeing - (fromEcbRate/toEcbRate) )/(fromEcbRate/toEcbRate) )*100;
			}
		} else if( currency == "DKK") {
			if(refCurrency === "EUR") {
				result = ecbRatioFormulaEur(toEcbRate, sellingRateForeing);
			}
			else if(tableType == 'PBZ-ISSUING' && columnNumber == 5){
				
				result = (sellingRateForeing - (fromEcbRate/toEcbRate)/(fromEcbRate/toEcbRate) )*100;
			} else {
				
				result = ((sellingRateForeing - (fromEcbRate/toEcbRate) )/(fromEcbRate/toEcbRate) )*100;
			}
		} else {
			return "-";
		}
	return Number(result).toFixed(2) + "%";
	
}

ecbRatioFormulaEur = function(ecbRate, currencyForeignRate){
	return (ecbRate/currencyForeignRate  - 1)*100;
}

formatNumber = function (value){
	return Number(value).toFixed(6);
}

function downloadFileText(tableType){
	var fileContentHead = "";
	var fileContentBody =  "";
	
	$.each($("div[data-type-table="+tableType+"]").find(".tbl2__head__highlist").find(".tbl__highlistItem"), function(keys, values){
		fileContentHead = fileContentHead + " " +$(values).text();
	});
	var iterator = 0;
	$.each($("div[data-type-table="+tableType+"]").find(".tbl2__highlist").find(".tbl2__highlistItem").find(".tbl__highlist"), function(keys, values){
       for(i = 0; i <$(values).find(".tbl__highlistItem").length; i++){
    	   var totalChar = $($("div[data-type-table="+tableType+"]").find(".tbl2__head__highlist").find(".tbl__highlistItem")[i]).text().length;
    	   var spaces = "";
    	   for(c = 0; c < totalChar; c++){
    		   spaces += " ";
    	   }
    	   fileContentBody = fileContentBody + " " + $($(values).find(".tbl__highlistItem")[i]).text() + spaces;
        }	
		fileContentBody = fileContentBody + "\n\r";
		
	});
	var fileContent = fileContentHead +"\n\r"+ fileContentBody;
	var fileName = 'download.txt';

	var blob = new Blob([fileContent], { type: 'text/plain' });
	var a = document.createElement('a');
	a.setAttribute('download', fileName);
	a.setAttribute('href', window.URL.createObjectURL(blob));
	a.click();
} 

function downloadFile(element){
	var fileContent = decodeURIComponent($(element).attr("data-download"));
	var fileName = 'download.xml';

	var blob = new Blob([fileContent], { type: 'text/plain' });
	var a = document.createElement('a');
	a.setAttribute('download', fileName);
	a.setAttribute('href', window.URL.createObjectURL(blob));
	a.click();
} 

function downloadFileCsv(element){
	var fileContent = decodeURIComponent($(element).attr("data-download"));
	var fileName = 'download.csv';

	var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
	var a = document.createElement('a');
	a.setAttribute('download', fileName);
	a.setAttribute('href', window.URL.createObjectURL(blob));
	a.click();
} 
//function to fill xlsx files
function s2ab(s) {
	  var buf = new ArrayBuffer(s.length);
	  var view = new Uint8Array(buf);
	  for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	  return buf;
	}

function downloadFileExcel(element){
	var fileContent = decodeURIComponent($(element).attr("data-download"));
	var fileName = 'download.xlsx';

	var blob = new Blob([s2ab(atob(data))], 
			{ type: 'text/plain' });
	var a = document.createElement('a');
	a.setAttribute('download', fileName);
	a.setAttribute('href', window.URL.createObjectURL(blob));
	a.click();
} 
										

function json2xml(tableType,config) {
	console.log("clicked");
	config = config || {};
	initConfigDefaults();
	var jsonObj = JSON.parse($("#exchange-rates-"+tableType.toLowerCase()).val());
	var out = '<?xml version="1.0" encoding="utf-8"?>' + parseJSONObject(jsonObj);
	$(".js-xml-"+tableType+"").attr("data-download", encodeURIComponent(out)); 
	function initConfigDefaults() {
		if(config.escapeMode === undefined) {
			config.escapeMode = true;
		}
		config.attributePrefix = config.attributePrefix || "_";
		config.arrayAccessForm = config.arrayAccessForm || "none";
		config.emptyNodeForm = config.emptyNodeForm || "text";
		if(config.enableToStringFunc === undefined) {
			config.enableToStringFunc = true; 
		}
		config.arrayAccessFormPaths = config.arrayAccessFormPaths || []; 
		if(config.skipEmptyTextNodesForObj === undefined) {
			config.skipEmptyTextNodesForObj = true;
		}
		if(config.stripWhitespaces === undefined) {
			config.stripWhitespaces = true;
		}
		config.datetimeAccessFormPaths = config.datetimeAccessFormPaths || [];
	}	
	function startTag(jsonObj, element, attrList, closed) {
		var resultStr = "<"+ ( (jsonObj!=null && jsonObj.__prefix!=null)? (jsonObj.__prefix+":"):"") + element+">";
		if(attrList!=null) {
			for(var aidx = 0; aidx < attrList.length; aidx++) {
				var attrName = attrList[aidx];
				var attrVal = jsonObj[attrName];
				if(config.escapeMode)
					attrVal=escapeXmlChars(attrVal);
				resultStr+=" "+attrName.substr(config.attributePrefix.length)+"='"+attrVal+"'";
			}
		}
		if(!closed)
			resultStr+="";
		else
			resultStr+="";
		return resultStr;
	}
	
	function endTag(jsonObj,elementName) {
		return "</"+ (jsonObj.__prefix!=null? (jsonObj.__prefix+":"):"")+elementName+">";
	}
	
	function endsWith(str, suffix) {
		return str.indexOf(suffix, str.length - suffix.length) !== -1;
	}
	function getNodePrefix(node) {
		return node.prefix;
	}
		
	function escapeXmlChars(str) {
		if(typeof(str) == "string")
			return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/\//g, '&#x2F;');
		else
			return str;
	}

	function unescapeXmlChars(str) {
		return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&#x2F;/g, '\/');
	}
	
	function jsonXmlSpecialElem ( jsonObj, jsonObjField ) {
		if((config.arrayAccessForm=="property" && endsWith(jsonObjField.toString(),("_asArray"))) 
				|| jsonObjField.toString().indexOf(config.attributePrefix)==0 
				|| jsonObjField.toString().indexOf("__")==0
				|| (jsonObj[jsonObjField] instanceof Function) )
			return true;
		else
			return false;
	}

	function jsonXmlElemCount ( jsonObj ) {
		var elementsCnt = 0;
		if(jsonObj instanceof Object ) {
			for( var it in jsonObj  ) {
				if(jsonXmlSpecialElem ( jsonObj, it) )
					continue;			
				elementsCnt++;
			}
		}
		return elementsCnt;
	}
	
	function parseJSONObject ( jsonObj ) {
		var result = "";

		var elementsCnt = jsonXmlElemCount ( jsonObj );
		
		if(elementsCnt > 0) {
			for( var it in jsonObj ) {
				
				if(jsonXmlSpecialElem ( jsonObj, it) )
					continue;			
				
				if(it.toUpperCase() != "STATUSCODE" && it.toUpperCase() != "STATUSMESSAGE"  ){
					
				var subObj = jsonObj[it];						
				
				var attrList = parseJSONAttributes( subObj )
				
				if(subObj == null || subObj == undefined) {
					result+=startTag(subObj, it, attrList, true);
				}
				else
				if(subObj instanceof Object) {
					
					if(subObj instanceof Array) {			
						result += "<exRate>"
						result+=parseJSONArray( subObj, it, attrList );		
						result += "</exRate>"
					}
					else if(subObj instanceof Date) {
						result+=startTag(subObj, it, attrList, false);
						result+=subObj.toISOString();
						result+=endTag(subObj,it);
					}
					else {
						var subObjElementsCnt = jsonXmlElemCount ( subObj );
						if(subObjElementsCnt > 0 || subObj.__text!=null || subObj.__cdata!=null) {
							result+=startTag(subObj, it, attrList, false);
							result+=parseJSONObject(subObj);
							result+=endTag(subObj,it);
						}
						else {
							result+=startTag(subObj, it, attrList, true);
						}
					}
				}
				else {
					result+=startTag(subObj, it, attrList, false);
					result+=parseJSONTextObject(subObj);
					result+=endTag(subObj,it);
				}
			}
			}
			
		}
		result+=parseJSONTextObject(jsonObj);
		
		return result;
	}
	function parseJSONAttributes ( jsonObj ) {
		var attrList = [];
		if(jsonObj instanceof Object ) {
			for( var ait in jsonObj  ) {
				if(ait.toString().indexOf("__")== -1 && ait.toString().indexOf(config.attributePrefix)==0) {
					attrList.push(ait);
				}
			}
		}
		return attrList;
	}
	
	function parseJSONTextAttrs ( jsonTxtObj ) {
		var result ="";
		
		if(jsonTxtObj.__cdata!=null) {										
			result+="<![CDATA["+jsonTxtObj.__cdata+"]]>";					
		}
		
		if(jsonTxtObj.__text!=null) {			
			if(config.escapeMode)
				result+=escapeXmlChars(jsonTxtObj.__text);
			else
				result+=jsonTxtObj.__text;
		}
		return result;
	}
	
	function parseJSONTextObject ( jsonTxtObj ) {
		var result ="";

		if( jsonTxtObj instanceof Object ) {
			result+=parseJSONTextAttrs ( jsonTxtObj );
		}
		else
			if(jsonTxtObj!=null) {
				if(config.escapeMode)
					result+=escapeXmlChars(jsonTxtObj);
				else
					result+=jsonTxtObj;
			}
		
		return result;
	}
	
	function parseJSONArray ( jsonArrRoot, jsonArrObj, attrList ) {
		var result = ""; 
		if(jsonArrRoot.length == 0) {
			result+=startTag(jsonArrRoot, jsonArrObj, attrList, true);
		}
		else {
			for(var arIdx = 0; arIdx < jsonArrRoot.length; arIdx++) {
				result+=startTag(jsonArrRoot[arIdx], jsonArrObj, parseJSONAttributes(jsonArrRoot[arIdx]), false);
				result+=parseJSONObject(jsonArrRoot[arIdx]);
				result+=endTag(jsonArrRoot[arIdx],jsonArrObj);						
			}
		}
		return result;
	}

  }

clearTable = function(tableType){
	
	$(origTables).each(function(index){
		if($(this).attr("data-type-table") == tableType){
			$("div[data-type-table="+tableType+"]").html('');
			$("div[data-type-table="+tableType+"]").html($(this).html());
		}
	});
}

getArchive = function (element, datePickerId, tableType) {
	var datePicker = $("#"+datePickerId);
	var d = new Date();
	var startingDate = formatDate(formatSlashedDate(datePicker.val().slice(0,10).split(".").join("/")));
	
	var euroDate = new Date("2023-01-01");
	var pickedDate = new Date(startingDate);
	var refCurrency = "&refCurrency=";
	var fromCurrency = "&fromCurrency=";
	if(pickedDate < euroDate){
		refCurrency += "HRK";
		fromCurrency += "HRK";
	}
	else{
		refCurrency += "EUR";
		fromCurrency += "EUR";
	}
	
	var endpoint = window.location.origin + $("#exchange-rates-"+tableType.toLowerCase()+"-endpoint-archive").val() + fromCurrency +"&toCurrency=CZK&datePickerStart="+startingDate+"&datePickerStop="+startingDate+""+refCurrency;
	clearTable(tableType);
	var isArchive = true;
//	getJsonAjax(endpoint, $("#exchange-rates-"+tableType.toLowerCase()), tableType, isArchive, datePickerId);
	getJsonAjaxControl(endpoint, element, tableType, isArchive, datePickerId, startingDate, 0);
}
  
getJsonAjax = function (endpoint, element, tableType, isArchive, datePickerId){
	console.log("invoked url: " + endpoint);	
	$.ajax({
		  method: "GET",
		  url: endpoint
		})
		.done(function( data ) {
			if(data != null){
				console.log("----" + JSON.stringify(data) +"----");
			  	$(element).val(JSON.stringify(data));
			  	createTable(tableType, isArchive, datePickerId);
			}
		});
}


getJsonAjaxControl = function (endpoint, element, tableType, isArchive, datePickerId, startingDate, counter){
	console.log("invoked url: " + endpoint);	
	$.ajax({
		  method: "GET",
		  url: endpoint
		})
		.done(function( data ) {
			if(data != null && JSON.parse(JSON.stringify(data)).statusCode == 200){
				console.log("----" + JSON.stringify(data) +"----");
				var datePicker = $("#"+datePickerId);
				var d = new Date();
				var startDate = startingDate;
				
				var euroDate = new Date("2023-01-01");
				var pickedDate = new Date(startingDate);
				var refCurrency = "&refCurrency=";
				var fromCurrency = "&fromCurrency=";
				if(pickedDate < euroDate){
					refCurrency += "HRK";
					fromCurrency += "HRK";
				}
				else{
					refCurrency += "EUR";
					fromCurrency += "EUR";
				}
				
				//formatDate(formatSlashedDate(datePicker.val().slice(0,10).split(".").join("/")))
				var endpoint = window.location.origin + $("#exchange-rates-"+tableType.toLowerCase()+"-endpoint-archive").val() + fromCurrency +"&toCurrency=CZK&datePickerStart="+startDate+"&datePickerStop="+startDate+""+refCurrency;
				clearTable(tableType);
				var isArchive = true;
				getJsonAjax(endpoint, $("#exchange-rates-"+tableType.toLowerCase()), tableType, isArchive, datePickerId);
			} else if(data != null){
				if(counter < 10){
					counter = counter + 1;
					var startDate = new Date(startingDate);
					startDate.setDate(startDate.getDate() -1);
					var formattedDate = formatDate(startDate);
					
					var euroDate = new Date("2023-01-01");
					var pickedDate = new Date(startingDate);
					var refCurrency = "&refCurrency=";
					var fromCurrency = "&fromCurrency=";
					if(pickedDate < euroDate){
						refCurrency += "HRK";
						fromCurrency += "HRK";
					}
					else{
						refCurrency += "EUR";
						fromCurrency += "EUR";
					}
					
					var endpoint = window.location.origin + $("#exchange-rates-"+tableType.toLowerCase()+"-endpoint-archive").val() + fromCurrency +"&toCurrency=CZK&datePickerStart="+formattedDate+"&datePickerStop="+formattedDate+""+refCurrency;
					getJsonAjaxControl(endpoint, element, tableType, isArchive, datePickerId, formattedDate, counter);
				}
			}
		});
}
function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}

function formatSlashedDate(date){
	var dateString = date; // Oct 23

	var dateParts = dateString.split("/");

	// month is 0-based, that's why we need dataParts[1] - 1
	var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]); 
	
	return dateObject.toDateString();
}

function findEcbArchiveJsonIndex(jsonEcb, selectedDate){
	var arrayCube = jsonEcb[0].Cube.Cube;
	var foundIndex = 0;
	var formatDateInTime = new Date(selectedDate).getTime();
	for(var i = 0; i < arrayCube.length; i++) {​​​​​​​​​

		if(formatDateInTime <= new Date(arrayCube[i].time).getTime()){​​​​

			 if(arrayCube[i].time == formatDate(selectedDate)){​​​​​​​​​
	
				 foundIndex = i;
		
				 return foundIndex;
	
			 }​​​​​​​​​
	
			 }​​​​ else{​​​​
	
				 return i;
	
			 }​​​​

		}
}
